/* ============================================================
   AMBER SWIM — section behaviours
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.as-reveal, .v4-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('as-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('as-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Open the Description accordion by default ----------
     Dawn's collapsible_tab block renders <details> closed with no
     "open by default" setting. This opens the tab whose summary reads
     "Description" on load, leaving the others collapsed. Reversible:
     remove initOpenDescription and its call.
  */
  function initOpenDescription() {
    var accordions = document.querySelectorAll('.product__accordion details, product-info details');
    accordions.forEach(function (details) {
      var summary = details.querySelector('summary .accordion__title, summary');
      if (!summary) return;
      var text = (summary.textContent || '').trim().toLowerCase();
      if (text.indexOf('description') === 0) {
        details.setAttribute('open', '');
      }
    });
  }

  /* ---------- Mix & Match builder ---------- */
  /*
     Each builder root carries data attributes from the section.
     Swatch buttons carry data-variant-id, data-price (cents), data-name.
     Adds top + bottom as two line items with a _mix_set property so an
     automatic discount in admin can target the pair. Discount % is
     display-only here; the real reduction is applied by Shopify at checkout.
  */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (window.Shopify && window.Shopify.formatMoney) {
      try { return window.Shopify.formatMoney(cents, format); } catch (e) {}
    }
    return '$' + value;
  }

  function initMixAndMatch() {
    var roots = document.querySelectorAll('[data-mix-root]');
    roots.forEach(function (root) {
      var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
      var discountPct = parseFloat(root.getAttribute('data-discount-pct')) || 0;
      var selected = { top: null, bottom: null };

      var totalPriceEl = root.querySelector('[data-mix-total-price]');
      var savingEl = root.querySelector('[data-mix-saving]');
      var addBtn = root.querySelector('[data-mix-add]');

      function render() {
        var sub = (selected.top ? selected.top.price : 0) +
                  (selected.bottom ? selected.bottom.price : 0);
        var bothChosen = selected.top && selected.bottom;
        var discounted = bothChosen && discountPct > 0
          ? Math.round(sub * (1 - discountPct / 100))
          : sub;

        if (totalPriceEl) {
          if (bothChosen && discountPct > 0) {
            totalPriceEl.innerHTML =
              '<s>' + formatMoney(sub, moneyFormat) + '</s>' +
              formatMoney(discounted, moneyFormat);
          } else {
            totalPriceEl.textContent = formatMoney(sub, moneyFormat);
          }
        }
        if (savingEl) {
          if (bothChosen && discountPct > 0) {
            savingEl.textContent = 'You save ' + formatMoney(sub - discounted, moneyFormat);
            savingEl.style.display = '';
          } else {
            savingEl.style.display = 'none';
          }
        }
        if (addBtn) addBtn.disabled = !bothChosen;
      }

      root.querySelectorAll('[data-mix-swatch]').forEach(function (sw) {
        sw.addEventListener('click', function () {
          var group = sw.getAttribute('data-mix-group'); // 'top' | 'bottom'
          root.querySelectorAll('[data-mix-group="' + group + '"]').forEach(function (s) {
            s.classList.remove('as-selected');
          });
          sw.classList.add('as-selected');
          selected[group] = {
            id: sw.getAttribute('data-variant-id'),
            price: parseInt(sw.getAttribute('data-price'), 10) || 0,
            name: sw.getAttribute('data-name') || ''
          };
          render();
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (!selected.top || !selected.bottom) return;
          addBtn.disabled = true;
          var setId = 'set-' + Date.now();
          var items = [
            { id: selected.top.id, quantity: 1, properties: { _mix_set: setId } },
            { id: selected.bottom.id, quantity: 1, properties: { _mix_set: setId } }
          ];
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { return r.json(); })
            .then(function () {
              // Refresh Dawn cart drawer / bubble if present
              return fetch('/?section_id=cart-drawer')
                .then(function (res) { return res.text(); })
                .then(function (html) {
                  var drawer = document.querySelector('cart-drawer');
                  if (drawer) {
                    var parsed = new DOMParser().parseFromString(html, 'text/html');
                    var fresh = parsed.querySelector('cart-drawer');
                    if (fresh) {
                      drawer.innerHTML = fresh.innerHTML;
                      drawer.classList.remove('is-empty');
                      if (typeof drawer.open === 'function') drawer.open();
                    }
                  } else {
                    window.location.href = '/cart';
                  }
                });
            })
            .catch(function () { window.location.href = '/cart'; })
            .finally(function () { addBtn.disabled = false; });
        });
      }

      render();
    });
  }

  function init() { initReveal(); initOpenDescription(); initMixAndMatch(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init in Shopify theme editor when a section is re-rendered
  document.addEventListener('shopify:section:load', init);
})();
